import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
    Input,
    Row,
    Card,
    Form,
    Select,
    Col,
    Divider,
    Spin,
    DatePicker
} from "antd";

//OTHER IMPORTS
import dayjs from 'dayjs';

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import CustomButton from "../../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import { accountStatus } from "../../../../../../components/facilities/AccountFacility";


const UnassignOfficer = (props) => {
    const { userData, pageTitleParam } = props;
    const { session } = userData;
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [currentOfficerOptions, setCurrentOfficerOptions] = useState([]);
    const [templateDetail, setTemplateDetail] = useState();
    const dateFormat = 'YYYY/MM/DD';


    useEffect(() => {
        defaultDate()
    }, []);

    function onCancel() {
        navigate("/detail-current-account", { state: state });
    }
    const defaultDate = () => {
        form.setFieldsValue({
            assignmentDate: dayjs(),
        })
    }
    const disabledAfterCurrentDate = (current) => {
        return current && current.valueOf() > Date.now();
    };
    const onSubmit = (formValues) => {
        const url = `${apiConfig.SavingsAccounts}/${state.id}`;
        const params = {
            command: "unassignSavingsOfficer",
        };


        const body = {
            unassignedDate: BOM.DateTime(
                formValues.unassignedDate,
                "only-date"
            ),
            dateFormat: "dd MMMM yyyy",
            locale: "en",
            method: "POST",
            session,
            params,
        };
        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.unassignSavingsGrpOfficerMsg);
                navigate("/detail-group-savings", {
                    state: { ...state, statusValue: state?.status?.value.toLowerCase() },
                });
                //STOP LOAD
                setIsLoading(false);
            }
        });
    };

    return (
        <MainLayout isEnableRightSidebar={true}>
            <TopContent
                pageTitle={pageTitleParam ? pageTitleParam : labelConfig.unassignSavingsGrpOfficer}
                pageItems={staticConfig.unassignSavingsOfficerBreadcrumbItems}
            />

            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}
                >
                    <Form form={form} layout="vertical" onFinish={onSubmit}>
                        <Row>
                            <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>
                            <Col span={12} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.unassignedOn}
                                    name="unassignedDate"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.date),
                                        },
                                    ]}
                                >
                                    <DatePicker
                                        disabledDate={disabledAfterCurrentDate}
                                        style={{ width: "100%", height: 35 }}
                                        format={dateFormat}

                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row>
                            <Divider />
                            <CustomButton
                                content="Submit"
                                style={{
                                    width: "10%",
                                    marginLeft: "auto",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                htmlType="submit"
                                backgroundColor="#15CCAE"
                                colorText="black"
                                hoverBackground="#4FECA0"
                            />

                            <CustomButton
                                content="Cancel"
                                style={{
                                    width: "10%",
                                    marginLeft: "1%",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                backgroundColor="#fff"
                                colorText="black"
                                hoverBackground="#F5F5F5"
                                onClick={onCancel}
                            />
                        </Row>
                    </Form>
                </Card>
            </Spin>
        </MainLayout>
    );
};

export default UnassignOfficer;
